/**
 * An organization's sport, normalised.
 *
 * `activeOrganization.sport` is a nullable free string on the wire, and several features have to
 * branch on it: which pitch set a coach is offered, which word a position gets, which field art
 * the depth chart draws. Each of those used to re-derive the fallback rule for itself, which is
 * how they can disagree about what an unrecognised value means.
 */
export type RosterSport = 'baseball' | 'softball';

/**
 * Normalises `activeOrganization.sport` onto the closed union.
 *
 * Baseball is the fallback for an unset or unrecognised sport, and deliberately so: it is what
 * every organization saw before any sport-specific behaviour existed, so a bad value degrades to
 * the old experience rather than to an empty screen.
 */
export const toRosterSport = (sport: string | null | undefined): RosterSport =>
  sport === 'softball' ? 'softball' : 'baseball';
